import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const benefitProgramObject = z.object({
  id: z.string().uuid(),
  name: z.string(),
  unitValue: z.number(),
  discountPercent: z.number(),
  calculationRules: z.string().nullish(),
  active: z.boolean(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type BenefitProgramType = z.infer<typeof benefitProgramObject>

export const propertyMap = {
  id: sql`id`,
  name: sql`name`,
  unitValue: sql`unit_value`,
  discountPercent: sql`discount_percent`,
  calculationRules: sql`calculation_rules`,
  active: sql`active`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
